import { query } from './api-consumer';

export default {
  async getGatewayStatus(token, shortId) {
    return query('getGatewayStatus', { token, shortId });
  },
};
